export const socialsData = {
    github: 'https://github.com/manvi-singhal',
    envelope: 'mailto:manvi.singhal03@gmail.com',
    hackerrank: 'https://www.hackerrank.com/creedorian?hr_r=1',
    linkedIn: 'https://www.linkedin.com/in/manvi-singhal-89aa53221/',
    instagram: 'https://www.instagram.com/astromanvi/',
    code: 'https://www.codechef.com/users/manvi_03',
    twitter: '',
    reddit: '',
    blogger: '',
    stackOverflow: '',
    gitlab: '',
    youtube: ''
}